import { modelName } from './constants';
export const getHomeGames = (state) => state[modelName].allList.games;
export const getLastUpdatedGames = (state) => state[modelName]
    .allList.lastUpdated;
export const getHomeCheats = (state) => state[modelName].allList.cheats;
export const getCount = (state) => state[modelName].count;
